import { render, staticRenderFns } from "./SaiquRewardList.vue?vue&type=template&id=4e880832&"
import script from "./SaiquRewardList.vue?vue&type=script&lang=js&"
export * from "./SaiquRewardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports